<mat-expansion-panel hideToggle>
  <mat-expansion-panel-header
    fxLayout="row"
    class="mat-expansion-panel-header-overlay"
  >
    <mat-panel-title fxLayoutAlign="start center"
      >Perfil tributario</mat-panel-title
    >
    <mat-panel-description fxLayoutAlign="end center">
      <button
        *ngIf="taxpayerId === 0"
        mat-icon-button
        (click)="addTaxpayer()"
        fxLayoutAlign="end start"
      >
        <mat-icon>add</mat-icon>
      </button>
      <mat-icon>expand_more</mat-icon>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <div
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="5px"
    *ngIf="activities.length > 0"
  >
    <mat-icon>keyboard_arrow_right</mat-icon>

    <button
      *ngIf="taxpayerId > 0 && activities!.length < 7"
      mat-icon-button
      (click)="editActivity(-1, -1)"
      fxLayoutAlign="center center"
      class="custom-button"
      color="accent"
    >
      <mat-icon>add</mat-icon>
    </button>
    <div (click)="addTaxpayer()" class="text-efect">PERFIL CONTRIBUYENTE</div>
  </div>
  <mat-radio-group
    aria-labelledby="radio-group-label"
    [(ngModel)]="mainActivitySelected"
  >
    <div
      *ngFor="let act of activities; let i = index"
      fxLayout="row"
      fxLayoutAlign="start center"
    >
      <mat-slide-toggle
        [checked]="act.isActive"
        (change)="switchActive(i, $event)"
        fxFlex="10"
        fxLayoutAlign="end start"
      >
      </mat-slide-toggle>
      <div (click)="editActivity(act.id, i)" fxFlex="40" class="text-efect">
        ACT. {{ act.label }}
      </div>
      <div fxFlex="26">
        <mat-radio-button
          class="radio-button"
          (click)="setMainActivity(act.id, true)"
          [value]="act.id"
        >
          Actividad principal
        </mat-radio-button>
      </div>
      <div fxFlex="10">
        {{ act.isActive ? 'Activo' : 'Inactivo' }}
      </div>
      <button
        mat-icon-button
        class="custom-button"
        fxLayoutAlign="center center"
        color="warn"
        (click)="deleteActivity(i, act.id)"
      >
        <mat-icon>delete_outline</mat-icon>
      </button>
    </div>
  </mat-radio-group>
</mat-expansion-panel>
